export enum MusicSymbol {
    Unused_first_Symbol,
    BLACK_HEAD,
    UPWARDS_TAIL,
    DOWNWARDS_TAIL,
    UPWARDS_DOUBLE_TAIL,
    DOWNWARDS_DOUBLE_TAIL,
    UPWARDS_TRIPLE_TAIL,
    DOWNWARDS_TRIPLE_TAIL,
    UPWARDS_QUAD_TAIL,
    DOWNWARDS_QUAD_TAIL,
    ROUND_HEAD,
    WHITE_HEAD,
    G_CLEF,
    F_CLEF,
    C_CLEF,
    BREVE,
    BREVE_REST,
    COMMON_TIME,
    CUT_TIME,
    WHOLE_REST,
    HALF_REST,
    QUARTER_REST,
    EIGHTH_REST,
    SIXTEENTH_REST,
    THIRTYSECOND_REST,
    SIXTYFOURTH_REST,
    FLAT,
    SHARP,
    NATURAL,
    DOUBLE_FLAT,
    DOUBLE_SHARP,
    ZERO,
    ONE,
    TWO,
    THREE,
    FOUR,
    FIVE,
    SIX,
    SEVEN,
    EIGHT,
    NINE,
    DOT,
    FERMATA,
    INVERTED_FERMATA,
    SPICCATO,
    TENUTO,
    MARCATO,
    MARCATISSIMO,
    INVERTED_MARCATISSIMO,
    P,
    F,
    S,
    Z,
    M,
    R,
    SEGNO,
    CODA,
    DRUM_CLEF,
    G_CLEF_SUB8,
    G_CLEF_SUPER8,
    G_CLEF_SUB15,
    G_CLEF_SUPER15,
    F_CLEF_SUB8,
    F_CLEF_SUPER8,
    F_CLEF_SUB15,
    F_CLEF_SUPER15,
    DOWN_BOW,
    MORDENT,
    INVERTED_MORDENT,
    TURN,
    INVERTED_TURN,
    LEFTHAND_PIZZICATO,
    RELEASE_PED,
    ENGAGE_PED,
    VA8,
    VB8,
    TRILL,
    MA15,
    MB15,
    HIGH,
    PLAY,
    MIC,
    SNAP_PIZZICATO,
    NATURAL_HARMONIC,
    EditPen,
    PEDAL_BRACKET,
    PEDAL_MIXED,
    PEDAL_SYMBOL
}
